import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContextState {
  context: string
}

const initialState: ContextState = {
  context: ''
}

const contextSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    // Add new content to the context
    appendToContext: (state, action: PayloadAction<string>) => {
      if (state.context) {
        state.context += `\n\n${action.payload}`
      } else {
        state.context = action.payload
      }
    },
    
    // Set the entire context (useful for initialization or reset)
    setContext: (state, action: PayloadAction<string>) => {
      state.context = action.payload
    },
    
    // Clear all context
    clearContext: (state) => {
      state.context = ''
    },
    
    // Add a formatted user input + AI response pair
    addConversationPair: (state, action: PayloadAction<{ userInput: string; aiResponse: string }>) => {
      const { userInput, aiResponse } = action.payload
      const newEntry = `User: "${userInput}"\nAI: ${aiResponse}`
      
      if (state.context) {
        state.context += `\n\n--- Conversation ${Date.now()} ---\n${newEntry}`
      } else {
        state.context = newEntry
      }
    }
  }
})

export const { 
  appendToContext, 
  setContext, 
  clearContext, 
  addConversationPair 
} = contextSlice.actions

export default contextSlice.reducer